<script>
    import {onMount} from 'svelte';
    // Nimen voi keksiä ja url tulee sivun tiedostosta. Tässä oikea .svelte -sivu ladataan sivun käyttöön
   // import Treenivinkit_04 from "../treenivinkit/kotitreenit.svelte";
   // import Treenivinkit_03 from "../treenivinkit/hiit.svelte";
   // import Treenivinkit_02 from "../treenivinkit/kehonhuolto.svelte";
    import Treenivinkit_01 from "../treenivinkit/toiminnallinen_opas.svelte";
    

    export let summary = false;
    export let treenivinkitUrl = "";
    let selected;

    // Copy paste ylhäältä tähän listaan ja uusin ylimmäksi aina. Muuta ei tarvi tehdä.
    // Tässä osoite linkitetään samaan muuttujaan
    const tekstit = [
     //   {cUrl: "kotitreenit", component: Treenivinkit_04},
     //   {cUrl: "hiit", component: Treenivinkit_03},
     //   {cUrl: "kehonhuolto", component: Treenivinkit_02},
        {cUrl: "toiminnallinen_opas", component: Treenivinkit_01}
    ];

    tekstit.forEach(teksti => {
        if (treenivinkitUrl == teksti.cUrl) {
            selected = teksti.component;
        }
    });

</script>

{#if summary && treenivinkitUrl === ""}
    <div class="row">
        {#each {length: 3} as _, i}
            <article class="news col-xs-12 col-md-4">
                <svelte:component this={tekstit[i].component} short="true"/>
            </article>
        {/each}
    </div>
{:else if treenivinkitUrl === ""}
    <!-- Kaikki kirjoitukset -->
    <div class="page">
        <div class="container">
            <h1>Ilmaiset oppaat ja vinkit</h1>
            <div class="row">
                {#each tekstit as teksti, i}
                    <article class="news col-xs-12 col-md-4 col-lg-4">
                        <svelte:component this={teksti.component} short="true"/>
                    </article>
                {/each}
            </div>
        </div>
    </div>
{:else if treenivinkitUrl != ""}
    <svelte:component this={selected}/>
{/if}
